import { render, staticRenderFns } from "./DealsList.vue?vue&type=template&id=5e0930de"
import script from "./DealsList.vue?vue&type=script&lang=js"
export * from "./DealsList.vue?vue&type=script&lang=js"
import style0 from "./DealsList.vue?vue&type=style&index=0&id=5e0930de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports